/** Orden de campos según spec inventario de gestión (cabecera + líneas). */

/** Ancho uniforme columnas de línea en grilla vista previa. */
export const GRID_LINE_COL_WIDTH = '82px';

export const CABECERA_FIELDS = [
  { field: 'tipo_nf', label: 'Tipo doc.', type: 'tipo_nf', width: '95px' },
  { field: 'cnpj', label: 'CNPJ', type: 'text', width: '120px' },
  { field: 'proveedor', label: 'Proveedor', type: 'readonly', width: '130px' },
  { field: 'oc_label', label: 'OC', type: 'readonly', width: '90px' },
  { field: 'almacen', label: 'Almacén', type: 'almacen', width: '120px' },
  { field: 'booking', label: 'Booking', type: 'text', width: '100px' },
  { field: 'nro_nf', label: 'N° NF', type: 'text', width: '80px' },
  { field: 'incoterm_id', label: 'Incoterm', type: 'incoterm', width: '220px' },
  { field: 'categoria', label: 'Categoría', type: 'text', width: '100px' },
  { field: 'especie', label: 'Especie', type: 'text', width: '100px' },
  { field: 'fecha_nf', label: 'Fecha NF', type: 'date', width: '120px' },
  { field: 'valor_total_nf', label: 'Total NF', type: 'number', width: '100px', decimals: 2 },
  { field: 'valor_total_prod', label: 'Total prod.', type: 'number', width: '100px', decimals: 2 },
  { field: 'peso_liquido', label: 'Peso líquido', type: 'number', width: '105px', decimals: 3 },
  { field: 'peso_bruto', label: 'Peso bruto', type: 'number', width: '105px', decimals: 3 },
  { field: 'tc_bcb', label: 'TC BCB', type: 'number', width: '90px', decimals: 4 },
];

/** Campos de gestión — visibles en Registros guardados. */
export const GESTION_FIELDS = [
  { field: 'tipo_movimiento', label: 'Tipo movimiento', type: 'tipo_movimiento', width: '115px' },
  { field: 'fecha_mov_almacen', label: 'Fecha movimiento', type: 'fecha_movimiento', width: '120px' },
  {
    field: 'estado_mercaderia',
    label: 'Disponibilidad producto',
    type: 'disponibilidad_producto',
    width: '145px',
  },
  { field: 'fecha_ingreso_puerto', label: 'Ingreso puerto', type: 'date', width: '120px' },
];

export const LINEA_FIELDS = [
  { field: 'paquetes', label: 'Paquetes', type: 'int', width: GRID_LINE_COL_WIDTH },
  { field: 'pcs_paq', label: 'Pcs/paq', type: 'int', width: GRID_LINE_COL_WIDTH },
  { field: 'total_pcs', label: 'Total pcs', type: 'calc', width: GRID_LINE_COL_WIDTH, decimals: 0 },
  { field: 'altura_rw', label: 'Altura RW', type: 'decimal', width: GRID_LINE_COL_WIDTH, decimals: 3 },
  { field: 'castigo_rw', label: 'Castigo RW', type: 'decimal', width: GRID_LINE_COL_WIDTH, decimals: 3 },
  { field: 'grado', label: 'Grado', type: 'grado', width: GRID_LINE_COL_WIDTH },
  { field: 'espesor', label: 'Espesor', type: 'dim', width: GRID_LINE_COL_WIDTH },
  { field: 'ancho', label: 'Ancho', type: 'dim', width: GRID_LINE_COL_WIDTH },
  { field: 'largo', label: 'Largo', type: 'dim', width: GRID_LINE_COL_WIDTH },
  { field: 'total_m3', label: 'Total M³', type: 'decimal_editable', width: GRID_LINE_COL_WIDTH, decimals: 3 },
  { field: 'precio_brl_unit_m3', label: 'BRL/u M³', type: 'calc', width: GRID_LINE_COL_WIDTH, decimals: 2 },
  { field: 'total_brl_m3', label: 'Total BRL', type: 'decimal_editable', width: GRID_LINE_COL_WIDTH, decimals: 2 },
  { field: 'tc_calculado', label: 'TC calc.', type: 'calc', width: GRID_LINE_COL_WIDTH, decimals: 3 },
  { field: 'diferencia', label: 'Diferencia', type: 'calc', width: GRID_LINE_COL_WIDTH, decimals: 4 },
  { field: 'precio_usd_unit_m3', label: 'USD/u M³', type: 'calc', width: GRID_LINE_COL_WIDTH, decimals: 2 },
  { field: 'total_usd_m3', label: 'Total USD', type: 'calc', width: GRID_LINE_COL_WIDTH, decimals: 2 },
];

export const ALL_GRID_FIELDS = [...CABECERA_FIELDS, ...LINEA_FIELDS];
// En registros guardados, la composición queda seguida inmediatamente por el N° NF.
const NRO_NF_FIELD = CABECERA_FIELDS.find((field) => field.field === 'nro_nf');
const RESTO_CABECERA_FIELDS = CABECERA_FIELDS.filter((field) => field.field !== 'nro_nf');
export const ALL_GRID_FIELDS_GUARDADAS = [
  NRO_NF_FIELD,
  ...RESTO_CABECERA_FIELDS,
  ...GESTION_FIELDS,
  ...LINEA_FIELDS,
];

export const CABECERA_PATCH_FIELDS = new Set(CABECERA_FIELDS.map((f) => f.field).concat(['incoterm_label']));
export const GESTION_PATCH_FIELDS = new Set(GESTION_FIELDS.map((f) => f.field));
export const LINEA_PATCH_FIELDS = new Set(
  LINEA_FIELDS.filter((f) => f.type !== 'calc').map((f) => f.field)
);

/** Columnas con valores numéricos (centrado en grilla). */
export function isNumericColumn(spec) {
  const t = spec?.type;
  return t === 'calc' || t === 'number' || t === 'decimal' || t === 'int' || t === 'dim' || t === 'decimal_editable';
}

/** Modo de sanitización al escribir en la grilla de vista previa. */
export function inputSanitizeMode(spec) {
  if (!spec) return null;
  if (spec.field === 'cnpj') return 'digits';
  if (spec.type === 'int') return 'int';
  if (spec.type === 'number' || spec.type === 'decimal' || spec.type === 'dim' || spec.type === 'decimal_editable') {
    return 'decimal';
  }
  return null;
}
